export default __webpack_public_path__ + "static/media/news3.94d943e5.png";